import {
  CmsPageQuery,
  CmsPageQueryDocument,
} from '@/server/graphql/getCmsPage/CmsPageQuery.generated';
import toJson from '@/shared/utils/toJson';

const ONE_DAY_IN_MS = 86_400_000;

const getPopupNotifications: WorkerQuery = async (args) => {
  const { context, fetch, addToQueue, notification } = args;
  const language = args.context.language;
  const site = args.context.site;
  const handle = notification?.data.content?.pages?.edges?.[0]?.node;
  if (!context.featureFlags.get('isNotificationPopupEnabled')) {
    return;
  }
  const variables = {
    filter: {
      language,
      handle,
      site,
      section: 'popup-notifications',
    },
  };
  const response = await fetch(CmsPageQueryDocument, variables);
  const { data } = await toJson<CmsPageQuery>(response);
  data?.content?.pages?.edges?.forEach(({ node }) =>
    addToQueue({
      data: node,
      type: 'popup',
      priority: 'high',
      sticky: true,
      dismissStrategy: { storage: 'cookie', ttl: ONE_DAY_IN_MS },
    }),
  );
};

export default getPopupNotifications;
